import { Cadet } from '../../../shared/types/scoreboard.types';

export interface CalloutPair {
  cadet1: Cadet;
  cadet2: Cadet;
}

export enum CalloutWinnerStatus {
  CADET1 = "cadet1",
  CADET2 = "cadet2",
  TIE = "tie",
}

export interface CalloutResult {
  winner: Cadet | null;
  loser: Cadet | null;
  pointTransfer: number;
  isTie: boolean;
}

export interface CalloutProcessingOptions {
  specialCadetName?: string;
  enableLogging?: boolean;
}

export interface CalloutPairingsProps {
  scoreboardData: Cadet[];
  onCalloutComplete: (updatedData: Cadet[]) => void;
  preloadedCalloutPairs?: CalloutPair[];
}
